/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Knee_HelpInputs */



/**
* | output |
* | --- |
* | "Smoothness of transition (higher = smoother ducking). 2-4dB Knee recommended." |
*
* @param {Audio_Description_Export_Automix_Knee_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_knee_help = /** @type {((inputs?: Audio_Description_Export_Automix_Knee_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Knee_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Douceur de transition (plus élevé = plus doux). Genou 2-4 dB recommandé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sanfter Übergang (höherer Wert = sanfteres Ducken). 2–4 dB Knie empfohlen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fluidità di transizione (più alto = ducking più fluido). Si consiglia un ginocchio da 2 a 4 dB.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Плавность перехода (чем выше уровень, тем плавнее приглушение звука). Рекомендуется уровень «колена» 2-4 дБ.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Suavidad de transición (cuanto más alto, más suave el efecto). Se recomienda un valor de rodilla de 2-4 dB.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("过渡平滑度（数值越高，闪避越平滑）。建议膝盖高度设置为 2-4dB。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("遷移の滑らかさ (値が高いほどダッキングがスムーズになります)。2 ～ 4 dB のニーを推奨します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तन की सुगमता (उच्चतर = अधिक सुगम डकिंग)। 2-4dB नी की अनुशंसा की जाती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Suavidade da transição (quanto maior, mais suave a atenuação). Recomenda-se um joelho de 2 a 4 dB.")
	return /** @type {LocalizedString} */ ("Smoothness of transition (higher = smoother ducking). 2-4dB Knee recommended.")
});